/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

function updateFade(el: HTMLElement): void {
  const scrollLeft = el.scrollLeft
  const maxScroll = el.scrollWidth - el.clientWidth

  if (maxScroll <= 0) {
    el.classList.remove('fade-left', 'fade-right', 'fade-both')
    return
  }

  const threshold = 1
  const atStart = scrollLeft <= threshold
  const atEnd = scrollLeft >= maxScroll - threshold

  el.classList.remove('fade-left', 'fade-right', 'fade-both')

  if (atStart && !atEnd) {
    el.classList.add('fade-right')
  } else if (!atStart && atEnd) {
    el.classList.add('fade-left')
  } else if (!atStart && !atEnd) {
    el.classList.add('fade-both')
  }
}

function bindBreadcrumb(el: HTMLElement): void {
  const handler = () => updateFade(el)

  el.addEventListener('scroll', handler, { passive: true })
  window.addEventListener('resize', handler)

  const resizeObserver = new ResizeObserver(handler)
  resizeObserver.observe(el)

  const active = el.querySelector('.breadcrumbs__item[aria-current="page"]') ??
    el.querySelector('.breadcrumbs__item:last-child')

  if (active instanceof HTMLElement) {
    requestAnimationFrame(() => {
      const maxScroll = el.scrollWidth - el.clientWidth
      const desired = active.offsetLeft + active.offsetWidth - el.clientWidth
      const clamped = Math.max(0, Math.min(desired, maxScroll))
      el.scrollLeft = clamped
      handler()
    })
  } else {
    handler()
  }
}

export function initBreadcrumbs(): void {
  const elements = document.querySelectorAll('.breadcrumbs__container')

  for (const element of elements) {
    if (element instanceof HTMLElement) {
      if (element.dataset.hydrated) continue
      element.dataset.hydrated = 'true'
      bindBreadcrumb(element)
    }
  }
}
